:host(limel-helper-line) {
    transition: opacity 0.2s ease;

    box-sizing: border-box;
    display: grid;

    min-width: 0; // prevents overflowing, if component is placed in flex containers

    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 0.6875rem;
    line-height: normal;

    color: rgb(var(--contrast-1200));
}

div {
    display: flex;
    justify-content: space-between;
    gap: 0.75rem;
    overflow: hidden;
    padding: 0 1rem;
}

:host(limel-helper-line.invalid) {
    --limel-h-l-grid-template-rows-transition-speed: 0.46s;
    --limel-h-l-grid-template-rows: 1fr;

    .helper-text {
        color: var(--limel-theme-error-color);
    }
}

.counter {
    flex-shrink: 0;
    margin-left: auto;
}

.helper-text,
.counter {
    padding-top: 0.125rem;
}

// This animates height of the helper line, from `0` to `auto`.
// To get this animation effect, the consumer component should
// add `hide` classed accordingly.
:host(limel-helper-line) {
    transition: grid-template-rows
        var(--limel-h-l-grid-template-rows-transition-speed, 0.46s)
        cubic-bezier(1, 0.09, 0, 0.89);
    grid-template-rows: var(--limel-h-l-grid-template-rows, 1fr);
}

:host(limel-helper-line.hide) {
    --limel-h-l-grid-template-rows-transition-speed: 0.3s;
    --limel-h-l-grid-template-rows: 0fr;
}
// End: animating height
